module.exports = __webpack_public_path__ + "img/kebijakan-pp.247e0db1.svg";